import FormSuccessMessage from "./FormSuccessMessage";

export default FormSuccessMessage;
